import { Component, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'form-checkbox',
    templateUrl: './form-checkbox.component.html',
    styleUrls: ['./form-checkbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatFormFieldModule, MatSlideToggleModule, ReactiveFormsModule, MatCheckboxModule],
    host: {
        class: 'form-checkbox',
    },
})
export class FormCheckboxComponent implements ControlValueAccessor, OnInit {
    @Input()
    public label = '';

    @Input()
    public hint = '';

    public inputControl: FormControl;

    private readonly ngControl: NgControl = inject(NgControl, { self: true, optional: true });

    constructor() {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    public ngOnInit(): void {
        this.inputControl = this.ngControl.control as FormControl;
    }

    public registerOnChange(): void {}

    public registerOnTouched(): void {}

    public writeValue(): void {}
}
